import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { customerMutations } from '@as-react/common-queries';
import { useMutation } from '@tanstack/react-query';
import { ButtonAlpha } from '@yonderland/andes-react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { useDeliveryState } from '../../../../context/CheckoutDeliveryContext';
import { makeGetIsLoggedIn } from '../../../../redux/session/selectors/SessionSelector';
import CustomerUtil from '../../../../util/CustomerUtil';
import { CustomerPhoneField } from '../CustomerPhoneField';
import { DeliverySheet } from '../DeliverySheet';
export const HomeDeliveryPhoneSelector = () => {
    var _a, _b, _c;
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const aemConfiguration = useAemConfig();
    const { defaultRequestParams, servicesEndpoint } = aemConfiguration;
    const isLoggedIn = useSelector(makeGetIsLoggedIn());
    const [{ info, openSelector, activeDeliveryOption }, dispatch] = useDeliveryState();
    const isOpen = openSelector === 'phone-number';
    const { updatePhoneNumber } = customerMutations({ servicesEndpoint, defaultRequestParams });
    const { mutate: updatePhoneNumberMutation } = useMutation(updatePhoneNumber());
    const { getValues } = useFormContext();
    const phoneNumber = (_b = (_a = info.deliveryAddress) === null || _a === void 0 ? void 0 : _a.phoneNumber) !== null && _b !== void 0 ? _b : (_c = info.customerDetails) === null || _c === void 0 ? void 0 : _c.mobilePhoneNumber;
    const initialPhoneNumber = CustomerUtil.convertPhoneNumberPrefix(phoneNumber, '00', '+') || '';
    const handleUpdate = () => {
        const { phoneNumber, savePhoneNumber } = getValues('delivery');
        if (phoneNumber === initialPhoneNumber) {
            closeSelector();
            return;
        }
        const newPhoneNumber = CustomerUtil.convertPhoneNumberPrefix(phoneNumber, '+', '00') || '';
        if (!savePhoneNumber || !newPhoneNumber) {
            updateDeliveryPhoneNumber(newPhoneNumber);
            closeSelector();
            return;
        }
        updatePhoneNumberMutation(newPhoneNumber, {
            onSuccess: () => {
                updateCustomerPhoneNumber(newPhoneNumber);
                updateDeliveryPhoneNumber(newPhoneNumber);
                closeSelector();
            },
        });
    };
    const closeSelector = () => {
        dispatch({ type: 'set_open_selector', payload: undefined });
    };
    const updateCustomerPhoneNumber = (phone) => {
        dispatch({ type: 'set_customer_phone_number', payload: phone });
    };
    const updateDeliveryPhoneNumber = (phone) => {
        dispatch({ type: 'set_delivery_phone_number', payload: phone });
    };
    const getContent = () => (_jsx(CustomerPhoneField, { prefix: "delivery.", isRequired: activeDeliveryOption === null || activeDeliveryOption === void 0 ? void 0 : activeDeliveryOption.requiresPhoneNumber, showSavePhoneNumberCheckbox: isLoggedIn }));
    const getCTAContent = () => (_jsx(ButtonAlpha, { fullWidth: true, theme: "branded", text: t('checkout:checkout.delivery.flyout.update'), onClick: handleUpdate }));
    const cancelChangePhoneNumber = () => {
        dispatch({ type: 'set_open_selector', payload: undefined });
    };
    return DeliverySheet({
        isOpen,
        onClose: cancelChangePhoneNumber,
        getContent,
        showCTA: true,
        getCTAContent,
    });
};
